/**
 * @module
 *
 * @import {AppScopeOptional} from './ts/global.ts';
 */

import {portal} from './core/portal.js';
import {publisher} from './core/publisher.js';
import {navigator} from './core/navigator.js';
import {special} from './special/special.js';
import {user} from './user/user.js';
import {Auth} from './user/auth/auth.js';
import {UserSettings} from './user/settings/settings.js';
import {NotificationManager} from './user/notification-manager.js';

/**
 * @typedef {typeof root & AppScopeOptional} App
 */

const root = /** @type {const} */ ({
  navigator,
  publisher,
  portal,
  user,
  settings: new UserSettings(),
  auth: new Auth(),
  special,
  notifications: new NotificationManager(),

  /**
   * @deprecated Use {@link user.lang}
   */
  get LANG() {
    DEBUG: console.warn('deprecated `${LANG}` use `${user.lang} plz`');
    return user.lang;
  },

  /**
   * @deprecated Use {@link portal.abbr}
   */
  get PORTAL() {
    DEBUG: console.warn('deprecated `${PORTAL}` use `${portal.abbr} plz`');
    return portal.abbr;
  },

  /**
   * @deprecated Use {@link user.fsk}
   */
  get FSK() {
    DEBUG: console.warn('deprecated `${FSK}` use `${user.fsk} plz`');
    return this.user.fsk;
  },
});

/**
 * @type {App}
 */
const app = root;

DEBUG: window.acng = app;

export {app};
